import { useTranslation } from 'react-i18next';
import { Badge } from '$lib/components/ui/Badge';

export interface PlaceholderProps {
  /** i18next key under `placeholder.<id>.title`, resolved at render time. */
  titleKey: string;
  /** i18next key under `placeholder.<id>.description`, resolved at render time. */
  descriptionKey: string;
  milestone: 'M3' | 'M4' | 'M5';
}

// Lightweight placeholder for routes whose content lands in a later milestone.
// Keeps the nav rail honest — every entry resolves to a real page.
//
// We accept i18n keys rather than already-translated strings because the
// router config is built at module load before any React render — that means
// the t() helper isn't available there. The keys are resolved here, so the
// label flips correctly when the user switches language.
export function Placeholder({ titleKey, descriptionKey, milestone }: PlaceholderProps) {
  const { t } = useTranslation();
  return (
    <section className="flex flex-1 items-center justify-center p-12">
      <div className="max-w-md text-center">
        <Badge tone="warning">{t('placeholder.comingIn', { milestone })}</Badge>
        <h2 className="mt-3 text-lg font-semibold text-fg">{t(titleKey)}</h2>
        <p className="mt-2 text-sm text-fg-muted">{t(descriptionKey)}</p>
      </div>
    </section>
  );
}
